import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setLeadingIndicatorsAction } from "@oldDashboard/legacyActions/dashboardClient";

interface UseLaunchKeyDatesProps {affiliateSelected: any, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, searching: boolean }
const useLeadingIndicators = (props: UseLaunchKeyDatesProps) => {
    const { affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate, searching } = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchLeadingIndicators();
    }, [searching, launchSelected]);
    

    const fetchLeadingIndicators = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getLeadingIndicators(affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate);
            if(response)
                setLeadingIndicatorsAction(response);
            else 
                setLeadingIndicatorsAction({data: [],header: [],show_launch_kpi: true});
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
     
    }
    return { isLoading, fetchLeadingIndicators }
}

export default useLeadingIndicators